import { render, staticRenderFns } from "./FlipCarousel.vue?vue&type=template&id=e4bedf5c&scoped=true"
import script from "./FlipCarousel.vue?vue&type=script&lang=js"
export * from "./FlipCarousel.vue?vue&type=script&lang=js"
import style0 from "./FlipCarousel.vue?vue&type=style&index=0&id=e4bedf5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bedf5c",
  null
  
)

export default component.exports